<template>
 <div class="archives">
<!--   古方详情-->
   <div class="outer-border margin-bottom-three">
     <el-row class="title-border-bottom">
       <div class="b-title fl">古方详情</div>
     </el-row>

     <div v-for="(form,index) in list" :key="index">
       <el-row>
         <el-col :span="24" class="medinum-kuokao">【古方名称】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">{{ form.gfName }}</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao">【古方追溯】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">{{ form.source }}</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao">【编码章节】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro"></el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao">【古方年代】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">{{ form.years }}</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao">【作&nbsp;&nbsp;&nbsp;&nbsp;者】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro"></el-col>
       </el-row>


       <el-row>
         <el-col :span="24" class="medinum-kuokao">【古籍原文】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">{{ form.originalText }}</el-col>
       </el-row>


<!--       &lt;!&ndash; 古代方剂 &ndash;&gt;-->
<!--       <el-row v-if="gdfj.length > 0">-->
<!--         <el-col :span="24">-->
<!--           <el-form-item class="margin-left-zero">-->
<!--             <table class="table">-->
<!--               <tr>-->
<!--                 <td :rowspan="Math.ceil(gdfj.length / 2) + 1" class="table-a">古代方剂</td>-->
<!--                 <td colspan="6">{{ form.da.gfName }}</td>-->
<!--               </tr>-->
<!--               <tr v-for="(itemG, indexG) in gdfj" :key="itemG.id" v-show="indexG % 2 == 0">-->
<!--                 <td>-->
<!--                   {{ gdfj[indexG].medicineName }}-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/jin.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="gdfj[indexG].anMedicineType == '0'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/fan.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="gdfj[indexG].xfxwMedicineType == '1'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/wei2.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="gdfj[indexG].xfxwMedicineType == '2'"-->
<!--                   />-->
<!--                 </td>-->
<!--                 <td>{{ gdfj[indexG].dosage }}{{ gdfj[indexG].unit }}</td>-->
<!--                 <td style="width: 20%">{{gdfj[indexG].zf}}</td>-->
<!--                 <td v-if="indexG < gdfj.length - 1">-->
<!--                   {{ gdfj[indexG + 1].medicineName }}-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/jin.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="gdfj[indexG + 1].anMedicineType == '0'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/fan.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="gdfj[indexG + 1].xfxwMedicineType == '1'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/wei2.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="gdfj[indexG + 1].xfxwMedicineType == '2'"-->
<!--                   />-->
<!--                 </td>-->
<!--                 <td-->
<!--                   v-if="indexG < gdfj.length - 1"-->
<!--                 >{{ gdfj[indexG + 1].dosage }}{{ gdfj[indexG + 1].unit }}</td>-->
<!--                 <td style="width: 20%" v-if="indexG < gdfj.length - 1">{{gdfj[indexG + 1].zf}}</td>-->
<!--               </tr>-->
<!--             </table>-->
<!--           </el-form-item>-->
<!--         </el-col>-->
<!--       </el-row>-->
<!--       &lt;!&ndash; 当代方剂 &ndash;&gt;-->
<!--       <el-row v-if="ddfj.length > 0">-->
<!--         <el-col :span="24">-->
<!--           <el-form-item class="margin-left-zero">-->
<!--             <table class="table">-->
<!--               <tr>-->
<!--                 <td :rowspan="Math.ceil(ddfj.length / 2) + 1" class="table-a">当代方剂</td>-->
<!--                 <td colspan="6">-->
<!--                   <span style="margin-left:14%">{{ form.da.gfName }}</span>-->
<!--                   <span class="fr">-->
<!--                        <el-button-->
<!--                          type="primary"-->
<!--                          class="btn-medium"-->
<!--                          style="margin-left:10px"-->
<!--                          @click="onChangeEvaluate"-->
<!--                          v-if="!evaluateInfo.id"-->
<!--                        >评价</el-button>-->
<!--                        <el-button-->
<!--                          type="warning"-->
<!--                          class="btn-medium"-->
<!--                          style="background-color: #f64420;"-->
<!--                          v-if="ddfj.length > 0 && !isYS"-->
<!--                          @click="addCar(form.da.cfId, 1)"-->
<!--                        >购药</el-button>-->
<!--                        <el-button-->
<!--                          type="warning"-->
<!--                          class="btn-medium"-->
<!--                          @click="editFangJi()"-->

<!--                        >修改方剂</el-button>-->
<!--                     &lt;!&ndash;  v-if="-->
<!--                         ysxzfj.length == 0-->
<!--                       " &ndash;&gt;-->
<!--                      </span>-->
<!--                 </td>-->
<!--               </tr>-->
<!--               <tr v-for="(itemD, indexD) in ddfj" :key="indexD.id" v-show="indexD % 2 == 0">-->
<!--                 <td>-->
<!--                   {{ ddfj[indexD].medicineName }}-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/ti.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD].rpMedicineType == '0'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/fan.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD].xfxwMedicineType == '1'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/wei2.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD].xfxwMedicineType == '2'"-->
<!--                   />-->
<!--                 </td>-->
<!--                 <td>{{ ddfj[indexD].dosage }}{{ ddfj[indexD].unit }}</td>-->
<!--                 <td style="width: 20%">{{ ddfj[indexD].zyzf }}</td>-->

<!--                 <td v-if="indexD < ddfj.length - 1">-->
<!--                   {{ ddfj[indexD + 1].medicineName }}-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/ti.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD + 1].rpMedicineType == '0'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/fan.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD + 1].xfxwMedicineType == '1'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/wei2.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD + 1].xfxwMedicineType == '2'"-->
<!--                   />-->
<!--                 </td>-->
<!--                 <td v-if="indexD < ddfj.length - 1">-->
<!--                   {{ ddfj[indexD + 1].dosage }}{{ ddfj[indexD + 1].unit }}-->
<!--                 </td>-->
<!--                 <td style="width: 20%" v-if="indexD < ddfj.length - 1">-->
<!--                   {{ddfj[indexD + 1].zyzf}}-->
<!--                 </td>-->
<!--                 &lt;!&ndash; <td v-if="indexD < ddfj.length - 2">-->
<!--                   {{ ddfj[indexD + 2].medicineName }}-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/ti.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD + 2].rpMedicineType == '0'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/fan.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD + 2].xfxwMedicineType == '1'"-->
<!--                   />-->
<!--                   <img-->
<!--                     :src="require('@/assets/list/wei2.png')"-->
<!--                     alt-->
<!--                     class="vertical-middle"-->
<!--                     v-if="ddfj[indexD + 2].xfxwMedicineType == '2'"-->
<!--                   />-->
<!--                 </td>-->
<!--                 <td-->
<!--                   v-if="indexD < ddfj.length - 2"-->
<!--                 >{{ ddfj[indexD + 2].dosage }}{{ ddfj[indexD + 2].unit }}</td> &ndash;&gt;-->
<!--               </tr>-->
<!--             </table>-->
<!--           </el-form-item>-->
<!--         </el-col>-->
<!--       </el-row>-->



       <el-row>
         <el-col :span="24" class="medinum-kuokao" >【主治功效】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">
         </el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao" >【处方制法】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">
         </el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao" >【煎 服 法】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">
         </el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="medinum-kuokao" >【注意事项】</el-col>
       </el-row>
       <el-row>
         <el-col :span="24" class="intro">
         </el-col>
       </el-row>
     </div>
   </div>
 </div>
</template>

<script>
export default {
name: "ancientDetails",
  data() {
     return {
       list: {
       },
       form: {
         da: {}
       },
       gdfj: [], //古代方剂
       ddfj: [], //当代方剂
     }
  },
  mounted() {
     this.getInfo()
  },
  methods: {
     getInfo() {
       let that = this;
       let url = "ancientPrescription/pageAncientPrescription";
       let params  = {
          id: this.$route.query.gfId
       }
       that.$http
         .post(url, params)
         .then(res => {
           res = res.data;
           if (res.code == 200) {
             console.log('res1312321', res.data.list)
             that.list = res.data.list
           } else {
             that.$message.error(res.msg);
           }
         })
         .catch(() => {
         });
     }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/JW/ancientDetails.vue